import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { toastStore } from 'shared/ui'
import { ClientsApi } from 'entities/Clients/api/clients'
import { type RowClient } from 'entities/Clients/model/RowClient'
import { DeleteClientModal } from 'pages/clients/ui/actions/deleteClient/ui/DeleteClientModal'

export const deleteClient = async (row: RowClient, onSuccess: () => void) => {
  const modalId = nanoid()

  const onClose = () => {
    modalStore.closeModal(modalId)
  }

  const onDelete = async () => {
    try {
      await ClientsApi.deleteClient(row.id)
      onSuccess()
      onClose()
      toastStore.add({
        type: 'success',
        title: 'Client removed',
      })
    } catch (error) {
      logger.error(error)
      toastStore.add({
        type: 'error',
        title: 'Something went wrong, try again.',
      })
    }
  }

  modalStore.addModal({
    id: modalId,
    title: 'Remove client',
    width: 480,
    pureContent: true,
    ModalContent: DeleteClientModal,
    ModalContentProps: { name: row.clientName, onClose, onDelete },
  })
}
